import { Params } from '@angular/router';
import { assignSafe, DefaultIcon } from '@summit/core';

export class SummitLink {
  //if displayed
  label?: string;
  hint?: string;
  icon?: DefaultIcon;
  class?: string;
  outlined?: boolean;
  //if used
  protocol: 'https' | 'tel' | 'mailto';
  path: string[];
  queryParams: Params;
  target: '_blank' | '_self' | '_parent' | '_top';
  action?: () => void;

  constructor(jsonData?: Partial<SummitLink>) {
    if (jsonData) {
      assignSafe(this, jsonData);
    }
    this.protocol ??= 'https';
    this.target ??= '_self';
  }

  getUrl(): string {
    return `${this.protocol}://${this.path.join('/')}`;
  }
}
